import { intersection } from 'lodash-es'

export type FormState = {
  selectedThemeId: string
  selectedTags: string[]
}

export function getFilteredThemes(themes: Core.Theme[], tags: string[]) {
  if (tags.length === 0) return themes

  // Get selected filter categories and attributes
  const selectedFilters = tags.reduce<Record<string, string[]>>((obj, tag) => {
    const [category, attribute] = tag.split(':')
    if (obj[category]) {
      obj[category].push(attribute)
    } else {
      obj[category] = [attribute]
    }
    return obj
  }, {})

  // Get theme matches for the selected filter attributes per selected filter category
  const themeMatchesPerCategory = Object.entries(selectedFilters).map(
    ([selectedFilterCategory, selectedFilterAttributes]) =>
      selectedFilterAttributes.flatMap((selectedFilterAttribute) =>
        themes.filter((theme) => [theme.attributes?.[selectedFilterCategory]].flat().includes(selectedFilterAttribute)),
      ),
  )

  return intersection(...themeMatchesPerCategory)
}
